import IntroJs from 'intro.js'
import 'scss/introjs.scss'

/**
 * Работа с турами
 * @mixin
 * @alias tour
 * @author Medvedev Denis
 * @vue-data {Object} intro - Тур
 * @vue-data {Object} introOptions - Опции тура по умолчанию
 */
export default {
  data() {
    const data = {
      intro: IntroJs(),
      introOptions: {
        tooltipClass: 'intro-tooltip',
        disableInteraction: false,
        exitOnEsc: true,
        exitOnOverlayClick: true,
        helperElementPadding: 10,
        hideNext: false,
        hidePrev: false,
        hintAnimation: true,
        hintPosition: 'top-middle',
        keyboardNavigation: true,
        overlayOpacity: 0.8,
        scrollPadding: 30,
        scrollTo: 'element',
        scrollToElement: true,
        showBullets: false,
        showButtons: true,
        showProgress: true,
        showStepNumbers: false,
        doneLabel: this.$t('Tenders.Complete'),
        nextLabel: this.$t('Common.Next'),
        prevLabel: this.$t('Common.Back'),
      },
    }
    data.stepsTemplate = {
      confirmReject: [
        {
          dataKey: 'spilka-formio',
          text: this.$t('formio.intro.fillData'),
          step: 1,
          position: 'middle-right'
        },
        {
          element: document.getElementsByClassName('formio-component required has-error')[0],
          text: this.$t('formio.intro.attentionRequired'),
          step: 2,
          position: 'middle-right'
        },
        {
          dataKey: 'btn-send',
          title: this.$t('Catalog.Send'),
          text: this.$t('formio.intro.ifCompleteSend'),
          step: 3,
          position: 'middle-right'
        },
        {
          dataKey: 'btn-dialog-template-second',
          title: this.$t('Common.Close'),
          text: this.$t('formio.intro.closeModal'),
          step: 4,
          position: 'middle-right'
        },
        {
          dataKey: 'save-as-draft',
          title: this.$t('Application.SaveAsDraft'),
          text: this.$t('formio.intro.saveDraft'),
          step: 5,
          position: 'middle-right'
        }
      ]
    }
    data.intro._introCompleteCallback = this.$_onComplete
    data.intro._introExitCallback = this.$_onExit
    return data
  },
  methods: {
    /**
     * Запустить тур
     * @param {Array, String} items - Шаги тура
     * Если items, то берем из stepsTemplate
     */
    $_startTour(items) {
      if (typeof items === 'string') {
        items = this.stepsTemplate[items]
      }
      this.intro.exit()
      if (!items?.length) { return }

      const steps = []
      items.sort((a, b) => a.step - b.step).forEach((obj) => {
        const element = obj.element ? obj.element : document.querySelector(`[data-qa=${obj.dataKey}]`)
        let step
        if (this.$_checkOnStepAvailability(element) || obj.float) {
          step = {
            intro: obj.text,
            title: obj.title,
            step: obj.step,
            tooltipClass: obj.tooltipClass,
            disableInteraction: true,
            hintPosition: obj.position || 'top-middle',
          }
          if (element) {
            step.element = element
            step.disableInteraction = true
          }
        }
        if (step) { steps.push(step) }
      })
      this.intro._options.steps = []
      this.intro._options.showProgress = steps.length !== 1
      if (steps.length !== 0) {
        this.intro.addSteps(steps)
        this.intro.start()
      }
    },
    /**
     * Проверка шага тура на возможность запуска
     * @param {Object} stepElement - элемент шага
     * @return {Boolean} - возможность запуска
     */
    $_checkOnStepAvailability(stepElement) {
      if (stepElement && stepElement.style.display !== 'none' && stepElement.offsetWidth !== 0 && stepElement.offsetHeight !== 0) {
        return true
      }
      return false
    },
    /**
     * Тур завершен
     */
    $_onComplete() {
      this.intro.setOption('hideNext', false)
    },
    /**
     * Пользователь досрочно вышел из тура (сохраняем результат)
     */
    $_onExit() {
      this.intro.setOption('keyboardNavigation', true)
      this.intro.setOption('showProgress', true)
      this.intro.setOption('showStepNumbers', false)
      this.intro.setOption('hideNext', false)

      document.querySelectorAll('.introjs-helperLayer').forEach(element => {
        element.remove()
      })
    },
  },
  mounted() {
    this.intro._introCompleteCallback = this.$_onComplete
    this.intro._introExitCallback = this.$_onExit
    this.intro.setOptions(this.introOptions)
    this.intro.setOption().oncomplete(() => {
      this.$_onComplete()
    })
    this.$root.$on('startTour', this.$_startTour)
  },
  beforeDestroy() {
    this.$root.$off('startTour', this.$_startTour)
  },
}
